/**
 * The navbar as a pure function of the session state (Navbar spec § State machine). Driven by
 * events it would return to idle on the `turn_complete` that arrives mid-meditation.
 */
import type {MachineStateName} from '@product/quies/hooks/useSessionMachine'

/** `first`: idle without the language and voice picks — before the first turn the list is the page. */
export type NavbarState = 'first' | 'idle' | 'receded' | 'hidden'

export interface NavbarStateInput {
    name: MachineStateName
    /** Whether the player is audibly playing right now (buffering counts as playing — the element
     *  is not paused). Only meaningful while `name === 'listening'`. */
    audioPlaying: boolean
    eyesClosed: boolean
}

export function navbarStateFor({name, audioPlaying, eyesClosed}: NavbarStateInput): NavbarState {
    if (eyesClosed) return 'hidden'
    switch (name) {
        case 'idle':
            return 'first'
        case 'composing':
        case 'delivering':
            return 'receded'
        case 'listening':
            return audioPlaying ? 'receded' : 'idle'
        default:
            return 'idle'
    }
}

export function pickersEnabled(state: NavbarState): boolean {
    return state === 'idle'
}
